import { SyntheticEvent } from 'react'
import { setModal, setShowModal } from '.'
import { TokenStatsProps, TokensState } from '../../../types/mfc'
import { IShareThing } from '../../components/presentation/Modals/Drawers/ShareThing'
import { TipProps } from '../../components/presentation/Modals/Drawers/Tip'
import {
    ABOUT,
    ACCOUNT,
    AUTHENTICATION,
    CHAT_COMMANDS,
    FIND_PINNED_ROOMS,
    FRIEND_CONFIRMATION,
    HIDDEN_MODELS,
    IGNORED_MODELS,
    LOUNGES,
    LOUNGE_AUTOPLAY_OPTIONS,
    MAIL_MESSAGE,
    MODELS_YOU_MAY_LIKE_POOL,
    MODEL_NOTIFICATIONS,
    MY_ACCOUNT,
    NEWS_CHAT_NOTIFICATIONS,
    NEWS_MANAGE_FOLLOWERS_LIST,
    NEWS_POST,
    NOTES,
    PARTICIPANTS,
    PROFILE,
    REPORT_USER,
    SEND_MAIL_MESSAGE,
    SETTINGS_HOME,
    SHARE_THING,
    SIGNUP,
    SUPPORT,
    TIPS,
    TIPS_SHARE,
    TOKENS,
    TOKEN_STATS,
    TOPIC,
    USER_FEEDBACK,
    WHITEBOARD,
} from '../../constants/drawer'
import { ConfirmationType, ModalKind } from '../../constants/enums'
import { NewsListUser } from '../../libraries/mfc/MfcJsTypes'
import { safeObj } from '../../utilities/safe'

type DrawerProps = {
    maxHeight?: boolean
    onBack?(): void
    stickyHeader?: boolean
    title?: string
}

export const closeDrawer = (immediate = false) => {
    // safeTransition(() => {
    setShowModal(ModalKind.Drawer, false, immediate)
    // }, skipTransition)
    // setShowModal(ModalKind.Drawer, false, immediate)
}

export const openAboutDrawer = (props: DrawerProps = {}) => {
    const { onBack } = props
    setModal(ModalKind.Drawer, {
        type: ABOUT,
        title: 'About MyFreeCams',
        stickyHeader: true,
        maxHeight: true,
        show: true,
        onBack,
    })
}

export const openAccountDrawer = () =>
    setModal(ModalKind.Drawer, { type: ACCOUNT, title: '\u200b', show: true })

type AuthenticationProps = {
    subject?: string
    redirect?: string
} & DrawerProps

export const openAuthenticationDrawer = ({
    onBack,
    subject = null,
    redirect = null,
}: AuthenticationProps = {}) =>
    setModal(ModalKind.Drawer, {
        type: AUTHENTICATION,
        title: 'LOG IN',
        stickyHeader: true,
        maxHeight: true,
        show: true,
        subject,
        redirect,
        onBack,
    })

export const openAutoplayOptionsDrawer = () =>
    setModal(ModalKind.Drawer, {
        type: LOUNGE_AUTOPLAY_OPTIONS,
        title: 'Autoplay Options',
        stickyHeader: true,
        show: true,
    })

export const openChatCommandsDrawer = () =>
    setModal(ModalKind.Drawer, {
        type: CHAT_COMMANDS,
        title: 'Chat Commands',
        stickyHeader: true,
        show: true,
    })

export const openContactSupportDrawer = (
    props?: SyntheticEvent | DrawerProps,
) => {
    const { onBack } = safeObj(props as DrawerProps)
    setModal(ModalKind.Drawer, {
        type: SUPPORT,
        title: 'CONTACT SUPPORT',
        stickyHeader: true,
        maxHeight: true,
        show: true,
        onBack,
    })
}

export const openFindPinnedRooms = () =>
    setModal(ModalKind.Drawer, {
        type: FIND_PINNED_ROOMS,
        title: 'Find a Room to Pin',
        show: true,
    })

export const openFriendConfirmationDrawer = (
    slug: string,
    confirmationType: ConfirmationType = ConfirmationType.Friend,
) =>
    setModal(ModalKind.Drawer, {
        type: FRIEND_CONFIRMATION,
        title: 'Are you sure?',
        confirmationType,
        slug,
        show: true,
    })

export const openHiddenModelsDrawer = (props: DrawerProps = {}) => {
    const { onBack } = props
    setModal(ModalKind.Drawer, {
        type: HIDDEN_MODELS,
        title: 'Hidden Models',
        stickyHeader: true,
        onBack,
        show: true,
    })
}

export const openIgnoredModelsDrawer = (props: DrawerProps = {}) => {
    const { onBack } = props
    setModal(ModalKind.Drawer, {
        type: IGNORED_MODELS,
        title: 'Ignored Models',
        stickyHeader: true,
        onBack,
        show: true,
    })
}

export const openLoungesDrawer = () =>
    setModal(ModalKind.Drawer, { type: LOUNGES, show: true })

export const openMailMessageDrawer = (props: object) => {
    setModal(ModalKind.Drawer, {
        type: MAIL_MESSAGE,
        ...props,
        title: 'Mail Message',
        stickyHeader: true,
        show: true,
    })
}

export const openModelNotificationsDrawer = (name: string) => {
    setModal(ModalKind.Drawer, {
        type: MODEL_NOTIFICATIONS,
        title: 'Model Notifications',
        stickyHeader: true,
        maxHeight: true,
        name,
        show: true,
    })
}

export const openModelsYouMayLikePoolDrawer = (slug: string) => {
    setModal(ModalKind.Drawer, {
        type: MODELS_YOU_MAY_LIKE_POOL,
        title: 'Advanced Selection',
        stickyHeader: true,
        maxHeight: false,
        slug,
        show: true,
    })
}

type MyAccountProps = { section?: string } & DrawerProps

export const openMyAccountDrawer = (props: MyAccountProps = {}) => {
    const { onBack, section, title } = props
    setModal(ModalKind.Drawer, {
        type: MY_ACCOUNT,
        title: title ?? 'My Account',
        stickyHeader: true,
        maxHeight: true,
        section,
        onBack,
        show: true,
    })
}

export const openNewsChatNotificationsDrawer = () => {
    setModal(ModalKind.Drawer, {
        type: NEWS_CHAT_NOTIFICATIONS,
        title: 'News Settings',
        stickyHeader: true,
        maxHeight: true,
        show: true,
    })
}

export const openNewsPostDrawer = () =>
    setModal(ModalKind.Drawer, {
        type: NEWS_POST,
        title: 'Create News Post',
        stickyHeader: true,
        maxHeight: true,
        show: true,
    })

export const openNewsListDrawer = (
    list: Array<NewsListUser>,
    listType: string,
    title: string,
) => {
    setModal(ModalKind.Drawer, {
        type: NEWS_MANAGE_FOLLOWERS_LIST,
        title,
        stickyHeader: true,
        maxHeight: true,
        list,
        listType,
        show: true,
    })
}

export const openNotesDrawer = (slug: string) => {
    setModal(ModalKind.Drawer, {
        type: NOTES,
        title: 'Notes',
        maxHeight: true,
        slug,
        show: true,
    })
}

export const openParticipantsDrawer = (id: number) =>
    setModal(ModalKind.Drawer, {
        type: PARTICIPANTS,
        title: 'Participants',
        stickyHeader: true,
        id,
        show: true,
    })

export const openProfileDrawer = (username: string) =>
    setModal(ModalKind.Drawer, {
        type: PROFILE,
        title: `${username}'s Profile`,
        stickyHeader: true,
        halfHeight: true,
        drawer: true,
        slugOrId: username,
        show: true,
    })

export const openReportUserDrawer = ({
    id,
    name,
}: {
    id: number
    name: string
}) => {
    setModal(ModalKind.Drawer, {
        type: REPORT_USER,
        title: 'Report a User',
        stickyHeader: true,
        maxHeight: true,
        id,
        name,
        show: true,
    })
}

export const openSendMailDrawer = (to?: string) => {
    setModal(ModalKind.Drawer, {
        type: SEND_MAIL_MESSAGE,
        title: 'Send MFC Mail',
        to,
        show: true,
    })
}

export const openSettingsDrawer = () => {
    setModal(ModalKind.Drawer, {
        type: SETTINGS_HOME,
        title: 'Settings',
        stickyHeader: true,
        show: true,
    })
}

export const openShareThingDrawer = (props: IShareThing) => {
    const { name } = props
    setModal(ModalKind.Drawer, {
        ...props,
        type: SHARE_THING,
        title: `${name} on MFC Share`,
        stickyHeader: true,
        maxHeight: false,
        show: true,
    })
}

interface ShareTipDrawerProps extends DrawerProps {
    name: string
}

export const openShareTipsDrawer = (props: ShareTipDrawerProps) => {
    const { name, onBack } = props
    const title = (name ? `${name}'s ` : '') + 'Tip Menu'
    setModal(ModalKind.Drawer, {
        type: TIPS_SHARE,
        name,
        title,
        stickyHeader: true,
        maxHeight: false,
        onBack,
        show: true,
    })
}

export const openSignupDrawer = (props?: SyntheticEvent | DrawerProps) => {
    const { onBack } = safeObj(props as DrawerProps)
    setModal(ModalKind.Drawer, {
        type: SIGNUP,
        title: 'CREATE A FREE MFC ACCOUNT',
        stickyHeader: true,
        maxHeight: true,
        onBack,
        show: true,
    })
}

export const openTipsDrawer = (props: TipProps) =>
    setModal(ModalKind.Drawer, {
        ...props,
        type: TIPS,
        title: 'TIP',
        stickyHeader: true,
        maxHeight: true,
        show: true,
    })

type TokensDrawerProps = DrawerProps & TokensState

export const openTokensDrawer = (props?: TokensDrawerProps) => {
    const { onBack, queue, product, productType, amount, processor } =
        safeObj(props)
    setModal(ModalKind.Drawer, {
        type: TOKENS,
        title: 'Purchase Tokens',
        stickyHeader: true,
        maxHeight: true,
        onBack,
        queue,
        product,
        productType,
        amount,
        processor,
        show: true,
    })
}

type TokenStatsDrawerProps = TokenStatsProps & DrawerProps

export const openTokenStatsDrawer = (props?: TokenStatsDrawerProps) => {
    const { onBack, modelList, statsData, title, tokenUsageHistory } =
        safeObj(props)
    setModal(ModalKind.Drawer, {
        type: TOKEN_STATS,
        title: title ?? 'Token Stats',
        stickyHeader: true,
        maxHeight: true,
        onBack,
        modelList,
        statsData,
        tokenUsageHistory,
        show: true,
    })
}

export const openTopicDrawer = (slug: string) =>
    setModal(ModalKind.Drawer, {
        type: TOPIC,
        slug,
        title: false,
        show: true,
    })

export const openUserFeedbackDrawer = (props: DrawerProps = {}) => {
    const { onBack } = props
    setModal(ModalKind.Drawer, {
        type: USER_FEEDBACK,
        title: 'USER FEEDBACK',
        stickyHeader: true,
        maxHeight: true,
        onBack,
        show: true,
    })
}

export const openWhiteboardDrawer = (name: string) => {
    setModal(ModalKind.Drawer, {
        type: WHITEBOARD,
        title: `${name}'s Whiteboard`,
        stickyHeader: true,
        maxHeight: true,
        identifier: name,
        hideTitle: true,
        showAvatar: false,
        show: true,
    })
}

if (typeof window !== 'undefined') {
    window.MFCShare_DhtmlMenu = openShareThingDrawer
}
